import styled from 'styled-components'
import { useSelector } from 'react-redux'

import * as sessionSelector from 'selectors/session'

import Notification from 'components/Shared/Notification/Index'
import SignInForm from './SignInForm'

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`

const SignInPanel = () => {
  const publicPartners = useSelector(sessionSelector.partners)

  return (
    <StyledWrapper>
      <Notification />
      <SignInForm publicPartners={publicPartners} />
    </StyledWrapper>
  )
}

export default SignInPanel
